import { useQuery } from '@tanstack/react-query';
import { isAddressEqual } from 'viem';
import { privateKeyToAddress } from 'viem/accounts';
import { useAccount } from 'wagmi';
import { SchemaSignerDto } from '../generated/apiTypes';
import { apiClient } from '../lib/apiClient';
import { useActiveSelectedSubaccount } from './useSelectedSubaccount';
import { useWalletStorage } from './useWalletStorage';

export const activeSignerQueryParams = (subaccountId: string | undefined) =>
  apiClient.queryOptions(
    'get',
    '/v1/linked-signer',
    { params: { query: { subaccountId: subaccountId || '', active: true } } },
    { enabled: Boolean(subaccountId) }
  );

export const useLinkedSigners = () => {
  const selectedSubaccount = useActiveSelectedSubaccount();
  return useQuery({
    ...activeSignerQueryParams(selectedSubaccount?.id || ''),
    select: (data): SchemaSignerDto[] | undefined => data?.data,
  });
};

export const useActiveSigner = () => {
  const selectedSubaccount = useActiveSelectedSubaccount();
  const { address } = useAccount();
  const { getSubaccountData } = useWalletStorage();

  const { data: linkedSigners, isLoading, error } = useLinkedSigners();

  const subaccountData = getSubaccountData(address, selectedSubaccount?.id);

  let activeSigner: SchemaSignerDto | undefined;

  if (linkedSigners && subaccountData && subaccountData.signingMethod === 'one-click') {
    activeSigner = linkedSigners.find(
      (linkedSigner) =>
        isAddressEqual(linkedSigner.signer, privateKeyToAddress(subaccountData.signerKey)) &&
        linkedSigner.isActive
    );
  }

  return {
    data: activeSigner,
    isLoading,
    error,
  };
};
